import type { CardImplementationDto } from "../../types/CardImplementationDto";
import type { CardImplementationEntity } from "../../types/CardImplementationEntity";

export const CardImplementationDtoToEntity = ({ ...rest }: Readonly<CardImplementationDto>): CardImplementationEntity => {
    return { ...rest };
};
